import { Dialog } from "@/components/ui/Dialog";
import { strings } from "@/lib/strings";

/** The `?` overlay documenting the entry form's shortcuts (docs/08 §8.3). */
export function ShortcutsOverlay({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const rows: Array<[string, string]> = [
    ["Tab / Shift-Tab", "Next / previous field"],
    ["Enter (in a text field)", "Move to the next field"],
    ["Ctrl-S or Cmd-S", "Save and new"],
    ["Ctrl-Shift-S", "Save and next organism (same specimen)"],
    ["s / i / r", "Set the focused antibiotic"],
    ["Backspace (on an antibiotic)", "Clear it back to not tested"],
    ["Esc", "Cancel"],
    ["?", "Show this list"],
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange} title={strings.entry.shortcuts}>
      <dl className="divide-y divide-slate-100">
        {rows.map(([keys, description]) => (
          <div key={keys} className="flex items-baseline justify-between gap-4 py-2">
            <dt className="font-mono text-xs text-slate-700">{keys}</dt>
            <dd className="text-right text-sm text-slate-600">{description}</dd>
          </div>
        ))}
      </dl>
    </Dialog>
  );
}
